'use client';

import React, { useState } from 'react';

// https://stackoverflow.com/questions/70612769/how-do-i-recognize-swipe-events-in-react
export const Swipeable = ({
  onSwipeUp,
  onSwipeDown,
  onSwipeLeft,
  onSwipeRight,
  className,
  children,
  propigate = false
}) => {
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);

  const [touchStartY, setTouchStartY] = useState(null);
  const [touchEndY, setTouchEndY] = useState(null);

  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(0);

  const minSwipeDistance = 50;
  const minXSwipeSpeed = 200;
  const minYSwipeSpeed = 1700;

  function onTouchStart(e) {
    if (!propigate) {
      e.stopPropagation();
    }
    setStart(Date.now());
    setTouchEndX(null);
    setTouchStartX(e.targetTouches[0].clientX);

    setTouchEndY(null);
    setTouchStartY(e.targetTouches[0].clientY);
  }

  function onTouchMove(e) {
    if (!propigate) {
      e.stopPropagation();
    }
    setTouchEndX(e.targetTouches[0].clientX);
    setTouchEndY(e.targetTouches[0].clientY);
  }

  function onTouchEnd() {
    setEnd((Date.now() - start) / 1000);
    if (touchStartX && touchEndX) swipeHorizontal();
    if (touchStartY && touchEndY) swipeVertical();
  }

  function swipeHorizontal() {
    const speed = Math.abs(touchStartX - touchEndX) / end;
    if (speed < minXSwipeSpeed) return;
    const xDistance = touchStartX - touchEndX;
    const yDistance = touchStartY - touchEndY;
    if (Math.abs(yDistance) >= Math.abs(xDistance)) {
      return;
    }

    const isLeftSwipe = xDistance > minSwipeDistance;
    const isRightSwipe = xDistance < -minSwipeDistance;

    if (isLeftSwipe && onSwipeLeft) {
      onSwipeLeft();
    }

    if (isRightSwipe && onSwipeRight) {
      onSwipeRight();
    }
  }

  function swipeVertical() {
    const speed = Math.abs(touchStartY - touchEndY) / end;
    if (speed < minYSwipeSpeed) return;
    const xDistance = touchStartX - touchEndX;
    const yDistance = touchStartY - touchEndY;
    if (Math.abs(xDistance) >= Math.abs(yDistance)) {
      return;
    }

    const isUpSwipe = yDistance > minSwipeDistance;
    const isDownSwipe = yDistance < -minSwipeDistance;

    if (isDownSwipe && onSwipeDown) {
      onSwipeDown();
    }

    if (isUpSwipe && onSwipeUp) {
      onSwipeUp();
    }
  }

  return (
    <div onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} className={className}>
      {children}
    </div>
  );
};
